// Marca "MATRUM" con estilo consistente: Cormorant Garamond, cursiva y tamaño destacado.
export default function MatrumWord({ className = "" }) {
  return <span className={`font-serif italic ${className}`}>matrum</span>;
}
